export function abbreviateNumber(value: number) {
    const suffixes = ['', 'k', 'm', 'b', 't']
    return abbreviate(value, suffixes)
}

export function abbreviateFileSize(value: number) {
    const suffixes = ['', ' KB', ' MB', ' GB']
    return abbreviate(value, suffixes)
}

// Heavily adjusted from: http://stackoverflow.com/a/10601315/98555
function abbreviate(value: number, suffixes: string[]) {
    // Handle values less than 1000
    if (value <= 1000) {
        return value.toString()
    }

    const numDigits = ('' + value).length
    const suffixIndex = Math.floor((numDigits - 1) / 3)

    // Reduce value to 0.1 - 99 range
    const normalisedValue = value / Math.pow(1000, suffixIndex)

    // If less than 100, we only want 2 significant figures so we get a whole number, like 123k,
    // and not 123.4k which takes up too many spaces
    let precision = 3
    if (normalisedValue < 100) {
        precision = 2
    }

    return normalisedValue.toPrecision(precision) + suffixes[suffixIndex]
}
